import { useQuery } from "@tanstack/react-query";
import { checkUserIsAdmin } from "../../services/apiAuth";

/**
 * Resolves whether the given user has admin permissions.
 *
 * @param {string | undefined} userId - Supabase auth user id.
 * @returns {{ isAdmin: boolean, isLoading: boolean }} Admin query state.
 */
export function useIsAdmin(userId) {
    const { data: isAdmin, isLoading } = useQuery({
        queryKey: ["isAdmin", userId],
        queryFn: () => checkUserIsAdmin(userId),
        enabled: Boolean(userId),
    });

    return { isAdmin: isAdmin ?? false, isLoading };
}
